import { createSelector } from 'reselect';

const selectWishList = state => state.wishlist;

const selectWishListQuantity = createSelector(
    selectWishList,
    wishList => wishList.quantity,
);

export { 
    selectWishListQuantity, 
};